module.exports = "/images/Ludwig_b88b48.jpg";